import { render, staticRenderFns } from "./QueryRoleSelector.vue?vue&type=template&id=47acde66"
import script from "./QueryRoleSelector.vue?vue&type=script&lang=js"
export * from "./QueryRoleSelector.vue?vue&type=script&lang=js"
import style0 from "./QueryRoleSelector.vue?vue&type=style&index=0&id=47acde66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports